module.exports = {
  apiHost: "https://api.project.sensoreal.com.au",
  assetsHost: "https://assets.project.sensoreal.com.au",
  formTemplate: "default",
  currency: {
    locale: "en-AU",
    code: "AUD",
  },
  langs: [{ code: "en", dir: "ltr" }],
  style: {
    primaryColor: "#000",
    textColor: "#fff",
  },
  header: {
    text: {
      en: "Your Favourite Selections",
      ar: "",
    },
    logo: false,
    color: "#fff",
  },
  footerLogo: false,
  links: {
    privacy: "",
    youtube: "",
    linkedin: "",
    twitter: "",
    instagram: "",
    facebook: "",
  },
  contact: {
    website: "",
    address: "",
    phone: "",
    email: "",
  },
};
